module.exports = "<div class=\"{{ vm.name }}\"\n    ng-if=\"vm.loader.loadingCount > 0\"\n    style=\"position: fixed; \n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 999;\n    background-color: rgba(255,255,255,0.5);\n    pointer-events: none; \n    display: flex;\n    align-items: center;\n    justify-content: center;\"> \n      <div class=\"spinner\"></div>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/common/stGlobalPreloader/stGlobalPreloader.html
// module id = 65
// module chunks = 0